export default __webpack_public_path__ + "static/media/JNFT.logo.white.2f99592f.svg";